import { render, staticRenderFns } from "./lx.vue?vue&type=template&id=617f94a7&scoped=true"
import script from "./lx.vue?vue&type=script&lang=js"
export * from "./lx.vue?vue&type=script&lang=js"
import style0 from "./lx.vue?vue&type=style&index=0&id=617f94a7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "617f94a7",
  null
  
)

export default component.exports